import type { AIDTColor } from './_typing';

export const gray: AIDTColor = Object.freeze({
  50: '#FAFAFD',
  100: '#F3F4FA',
  200: '#F1F1F6',
  300: '#D8D8E2',
  400: '#9B9BA9',
  500: '#77778A',
  600: '#616177',
  700: '#48485C',
  800: '#2E2E3C',
  900: '#1E1E1E',
  950: '#B2B2B2', // cs, korean middle bg color
  0: '#',
} as const);
